import "./search-btn.scss";

let search = document.getElementById('search-mobile');
let searchMain = document.getElementById('search-main');
let searchBtn = document.getElementById('search-btn');
let searchMainBtn = document.getElementById('search-main-btn');

searchBtn.addEventListener('click', function () {
    search.classList.toggle('hidden');
});

searchMainBtn.addEventListener('click', function (e) {
    searchMain.classList.toggle('hidden');
});

$(document).click( function(e){
    if ( $(e.target).closest('.header__search').length ) {
        // клик внутри элемента
        return;
    }
    if ( $(e.target).closest('.search-btn_main').length ) {
        // клик внутри элемента
        return;
    }

    if (searchMain.classList.contains('hidden') ) {

        return;
    }
    // клик снаружи элемента
    searchMain.classList.toggle('hidden');
});